import React from "react";
import { useTranslation } from "react-i18next";
import Form from "~/common/components/Form";
import Input from "~/common/components/Input";
import NumberInput from "~/common/components/NumberInput";

const ProfileEditForm = ({ useForm, emailReceiveCheck, emailReceiveTerm }) => {
	const { t } = useTranslation();
	return (
		<Form useForm={useForm} className="profile-basic">
			<Input
				label={t("pages.myPage.AccountPage.components.ProfileEditForm.inputName")}
				name="UserProfile.name"
				required
				limitLength={8}
			/>
			<Input
				label={t("pages.myPage.AccountPage.components.ProfileEditForm.inputEmail")}
				name="UserProfile.id"
				disabled
			/>
			<NumberInput
				label={t("pages.myPage.AccountPage.components.ProfileEditForm.inputPhone")}
				type="phone"
				name="UserProfile.phone"
				required
			/>
			<Input
				label={t("pages.myPage.AccountPage.components.ProfileEditForm.inputDepartment")}
				name="UserProfile.department"
				limitLength={12}
			/>
			<Input
				label={t("pages.myPage.AccountPage.components.ProfileEditForm.inputPosition")}
				name="UserProfile.position"
				limitLength={6}
			/>
			<div className="f__group">
				<div className="f__label">
					{t("pages.myPage.AccountPage.components.ProfileEditForm.f__label")}
				</div>
				<div className="f__control">
					<div className="checkbox">
						<label className={`checkbox-custom`}>
							<input
								type="checkbox"
								onChange={emailReceiveCheck}
								checked={emailReceiveTerm}
								name="checkbox"
							/>
							<span className="checkmark" />
							<span className="checkbox-label">
								{t(
									"pages.myPage.AccountPage.components.ProfileEditForm.checkbox-label"
								)}
							</span>
						</label>
					</div>
				</div>
			</div>
		</Form>
	);
};

export default ProfileEditForm;
